module.exports = __webpack_public_path__ + "assets/chevron-right-6e94a1.svg";